import { render, staticRenderFns } from "./walletBankDetails.vue?vue&type=template&id=1347fcb0&scoped=true"
import script from "./walletBankDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./walletBankDetails.vue?vue&type=script&setup=true&lang=js"
import style0 from "./walletBankDetails.vue?vue&type=style&index=0&id=1347fcb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1347fcb0",
  null
  
)

export default component.exports